export default __webpack_public_path__ + "static/contact-talk-9ba30e61d689979a7b02634bbf34f117.png";